
import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_EVENT_DISPATCHER from "./KAMPYLE_EVENT_DISPATCHER";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import MDIGITAL_CONFIGURATION from "./MDIGITAL_CONFIGURATION";
import MDIGITAL_LOGGER from "./MDIGITAL_LOGGER";
import MDIGITAL_FORM_STATE from "./MDIGITAL_FORM_STATE";
import KAMPYLE_INTEGRATION from './KAMPYLE_INTEGRATION';
import KAMPYLE_MESSAGE from "./KAMPYLE_MESSAGE";

  function triggerSdkError(method) {
    var eventData = {
      errorMessage: KAMPYLE_CONSTANT.LOG_MESSAGES.ERROR_ONSITE_SDK_CONFIGURATION_MISSING.replace('{{METHOD}}', method)
    };
    KAMPYLE_EVENT_DISPATCHER.triggerError(eventData);
    MDIGITAL_LOGGER.warn(eventData.errorMessage);
  }

  function loadForm(formId) {
    if (MDIGITAL_CONFIGURATION.isOnsiteConfigurationMissing()) {
      triggerSdkError('loadForm');
      return false;
    }

    var formState = KAMPYLE_DATA.getFormState(formId);
    if (!formState) {
      KAMPYLE_UTILS.showWarning('Error fetching data for form id ' + formId);
      return false;
    }

    if (!MDIGITAL_FORM_STATE.isFormFullyLoaded(formId)) {
      KAMPYLE_EVENT_DISPATCHER.trigger('neb_loadForm', { formId: formId });
    }

    return true;
  }

  function showForm(formId, options) {
    if (MDIGITAL_CONFIGURATION.isOnsiteConfigurationMissing()) {
      triggerSdkError('showForm');
      return false;
    }

    options = options || {};
    var formState = KAMPYLE_DATA.getFormState(formId);

    if (!formState) {
      KAMPYLE_UTILS.showWarning('Error fetching data for form id ' + formId);
      return false;
    }

    if( KAMPYLE_DATA.getMemoryData('inviteLoadedAndShown')){
      KAMPYLE_UTILS.showWarning('There is already an invite displayed');
      return false;
    }

    if (KAMPYLE_FUNC.isAnyOtherFormAlreadyShown(formId,true)) {
      KAMPYLE_UTILS.showWarning('There is already a form displayed');
      return false;
    }
    
    if (!MDIGITAL_FORM_STATE.isFormFullyLoaded(formId)) {
      loadForm(formId);
    }

    options.triggerType = options.triggerType || 'ByCode';
    //Save data to send to the form so once it is ready it will accept it
    KAMPYLE_DATA.saveFormExtraData(formId, options);

    var extraData = {
      formId: formId,
    };
    for (var prop in options) {
      if (options.hasOwnProperty(prop)) {
        extraData[prop] = options[prop];
      }
    }

    KAMPYLE_EVENT_DISPATCHER.trigger('neb_sdkShowForm', { formId: formId, triggerType: options.triggerType });
    
    return true;
  }

  function closeFormById(formId) {
    var formState = KAMPYLE_DATA.getFormState(formId)
    if(!(formState && formState.shown)) {
      return false;
    }

    var isFormSubmitted = formState.isCurrentlySubmitted;
    KAMPYLE_EVENT_DISPATCHER.trigger('neb_formClosed', { formId: formId , isFormSubmitted: isFormSubmitted});
    return true;
  }

  function getCloseFormByConditionFunc(value) {
    switch (value) {
      case KAMPYLE_CONSTANT.CLOSE_FORM_PARAM_VALUES.ALL:
        return function () {return true}

      case KAMPYLE_CONSTANT.CLOSE_FORM_PARAM_VALUES.EMBEDDED:
        return function (form) {return  form  && form.formType === KAMPYLE_CONSTANT.CLOSE_FORM_PARAM_VALUES.EMBEDDED}

      case KAMPYLE_CONSTANT.CLOSE_FORM_PARAM_VALUES.MODAL:
        return function (form) {
          var displayType = KAMPYLE_DATA.getDisplayType(form)
          return displayType === KAMPYLE_CONSTANT.DISPLAY_TYPES.ANIMATION || displayType === KAMPYLE_CONSTANT.DISPLAY_TYPES.LIGHTBOX
        }
        
      default:
        return function () {return false}
    }
  }

  function closeForm(value) {
    if (MDIGITAL_CONFIGURATION.isOnsiteConfigurationMissing()) {
      triggerSdkError('closeForm');
      return false;
    }

    if (!isNaN(value)) {
      return closeFormById(value)
    }

    var allForms = KAMPYLE_DATA.getAllForms();
    var conditionFunc = value && getCloseFormByConditionFunc(value.toLowerCase())

    var len = allForms.length, curr, result = false;
    for (var i = 0; i < len; i++ ) {
      curr = allForms[i];
      if (conditionFunc && conditionFunc(curr)) {
        // We want to return true if we close at least one form
       result = closeFormById(+curr.formId) || result
      }
    }

    return result
  }

  function updatePageView() {
    if (MDIGITAL_CONFIGURATION.isOnsiteConfigurationMissing()) {
      triggerSdkError('updatePageView');
      return false;
    }
    KAMPYLE_EVENT_DISPATCHER.trigger('neb_sdkPageView');
  }

  function isSurveyDisplayed() {
    if (MDIGITAL_CONFIGURATION.isOnsiteConfigurationMissing()) {
      triggerSdkError('isSurveyDisplayed');
      return false;
    }
  	if (KAMPYLE_FUNC.isAnyInviteShown() || KAMPYLE_FUNC.isAnyOtherFormAlreadyShown()) {
  		return true;
    }
    KAMPYLE_EVENT_DISPATCHER.trigger('neb_sdkSurveyDisplayed');
  	return false;
  }

  function startInviteTargeting(){
    if (MDIGITAL_CONFIGURATION.isOnsiteConfigurationMissing()) {
      triggerSdkError('startInviteTargeting');
      return false;
    }
  	if (!KAMPYLE_DATA.isFeatureEnabled(KAMPYLE_CONSTANT.PROPERTY_SETTINGS.MANUALLY_INVITE_TARGETING)) {
			KAMPYLE_UTILS.showWarning('Manually invite targeting feature is disabled');
			return false;
  	}

  	KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_MANUALLY_INVITE_TARGETING,{skipButtonTargeting: true, skipInviteTargeting:false});
  }
  

  function startLogger(){
    MDIGITAL_LOGGER.setLoggerStatus(true);
  }
  function stopLogger(){
    KAMPYLE_DATA.deleteData('mdLogger');
  }
  function printMdigitalLogs(){
    MDIGITAL_LOGGER.printLogs();
  }

  function collectIntegrationData(integrationName) {
    var integration = KAMPYLE_INTEGRATION.getIntegrationData(integrationName);
    if (!integration) {
      console.log('no integration data!');
      return;
    }
    var messageData = { action: "updateIntegrationData", integrations : integration, __isDigitalAction: true };
    KAMPYLE_MESSAGE.updateMessageForAllLoadedForms(messageData);
    return integration;
  }

  export default {
    loadForm: loadForm,
    showForm: showForm,
    closeForm: closeForm,
    updatePageView: updatePageView,
    isSurveyDisplayed: isSurveyDisplayed,
    startInviteTargeting : startInviteTargeting,
    collectIntegrationData : collectIntegrationData,

    startLogger:startLogger,
    stopLogger:stopLogger,
    printMdigitalLogs:printMdigitalLogs

  };

